<template>
  <v-row>
    <v-col cols="12">
      <v-data-table class="sm-font400-13 textTable--text" :headers="headers" :items="items" hide-default-footer
                    no-results-text="دیتایی وجود ندارد!" :loading="loading" loading-text="Loading..." item-key="id"
                    show-select
                    v-model="idList" @input="updateIds">
        <template v-slot:[`item.course_type`]="{ item }">
          <p class="orangeButton--text backOrange rounded-xl px-6 py-1 mt-2" v-if="item.course_type === 'Online'">کوچینگ</p>
          <p class="blueButton--text backBlue rounded-xl px-6 py-1 mt-2" v-if="item.course_type === 'Online_Offline'">تکمیلی</p>
          <p class="purpleButton--text backpurple rounded-xl px-6 py-1 mt-2" v-if="item.course_type === 'Offline'">بوتکمپ</p>
        </template>
        <template v-slot:[`item.is_active`]="{ item }">
          <v-switch :input-value="item.is_active" @click="toggleStatusById(item)" inset readonly></v-switch>
        </template>

        <template v-slot:[`item.category_data`]="{ item }">
          <div>{{ item.category_data?.title || 'ندارد' }}</div>
        </template>

        <template v-slot:[`item.registration_deadline`]="{ item }">
          {{ item.registration_deadline | moment("jYYYY/jMM/jDD") }}
        </template>

        <template v-slot:[`item.startDate`]="{ item }">
          {{ item.start | moment("jYYYY/jMM/jDD") }}
        </template>

        <template v-slot:[`item.endDate`]="{ item }">
          {{ item.end | moment("jYYYY/jMM/jDD") }}
        </template>

        <template v-slot:[`item.teachers_data`]="{ item }">
          {{ item.teachers_data[0]?.first_name}}
          {{ item.teachers_data[0]?.last_name}}
        </template>


        <template v-slot:[`item.actions`]="{ item }">
          <v-btn @click="addUser(item)" icon>
            <img src="@/assets/Icon/Table/user.svg" alt="">
          </v-btn>
          <v-btn @click="editCourse(item)" icon>
            <img src="@/assets/Icon/Table/edit-2.svg" alt="">
          </v-btn>
          <v-btn @click="archiveCourse(item)" icon>
            <img src="@/assets/Icon/Table/archive-tick.svg" alt="">
          </v-btn>
        </template>
      </v-data-table>
    </v-col>
    <v-col cols="12">
      <v-pagination v-model="filterSearch.page" :length="totalPages" @input="changePage"
                    color="thirdColor"></v-pagination>
    </v-col>


    <v-dialog v-model="showUpdateStatus" width="500">
      <v-card class="pa-10  text-center rounded-xl">
        <h3 class="mb-5">آیا از فعال/غیرفعال کردن دوره {{updatingItem.title}} مطمئن هستید؟</h3>
        <v-btn @click="showUpdateStatus = false" elevation="0" class="black--text border rounded-lg mt-3 me-4"
               height="32">بازگشت
        </v-btn>
        <v-btn :loading="loadingStatus" elevation="0" @click="updateStatusById" color="primary"
               class="white--text rounded-lg mt-3" height="32">فعال/غیرفعال کردن
        </v-btn>
      </v-card>
    </v-dialog>
    <v-dialog v-model="showArchive" width="500">
      <v-card class="pa-10  text-center rounded-xl">
        <h3 class="mb-5">آیا از آرشیو دوره {{ updatingItem.title }} مطمئن هستید؟</h3>
        <v-btn @click="showArchive = false" elevation="0" class="black--text border rounded-lg mt-3 me-4"
               height="32">بازگشت
        </v-btn>
        <v-btn :loading="loadingArchive" elevation="0" @click="confirmArchive" color="secondary"
               class="white--text rounded-lg mt-3" height="32">آرشیو کردن
        </v-btn>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import courseApi from "@/Services/modules/courses"

export default {
  name: "data-table",
  props: {
    items: {
      type: Array
    },
    loading: {
      type: Boolean
    },
    ids: {
      type: Array
    },
    filterSearch: {
      type: Object
    },
    totalPages: {
      type: Number
    },
  },
  data() {
    return {
      loadingStatus: false,
      loadingArchive: false,

      idList: this.ids,
      showUpdateStatus: false,
      showArchive: false,
      updatingItem: {},
      headers: [
        {text: "عنوان ایستگاه", value: "title", align: 'center', width: "250"},
        {text: "عنوان کلاس", value: "short_description", align: 'center', width: "250"},
        {text: "نوع دوره", value: "course_type", align: 'center'},
        // {text: "مستقل/زیردوره", value: "structure", align: 'center'},
        {text: "نام دوره کوچینگ", value: "category_data", align: 'center'},
        {text: "مهلت ثبت نام", value: "registration_deadline", align: 'center'},
        {text: "تاریخ شروع دوره", value: "startDate", align: 'center'},
        {text: "تاریخ پایان دوره", value: "endDate", align: 'center'},
        {text: "مربی دوره", value: "teachers_data", align: 'center'},
        // {text: "فعال/غیرفعال", value: "is_active", align: 'center'},
        {text: "ظرفیت باقیمانده", value: "remaining_capacity", align: 'center'},
        {text: "ساعت برگزاری", value: "event_time", align: 'center'},
        {text: "عملیات", value: "actions", align: "center", width: 250},
      ],
    }
  },
  methods: {
    redirectToView(item) {
      console.log(item);
    },
    toggleStatusById(item) {
      this.showUpdateStatus = true
      this.updatingItem = item
    },
    editCourse(item) {
      if (item.structure === "SubCourse") {
        this.$router.push(`/courses/class/edit/${item.id}`)
      } else {
        this.$router.push(`/courses/class/edit-independent/${item.id}`)
      }
    },
    archiveCourse(item) {
      this.showArchive = true
      this.updatingItem = item
    },
    updateStatusById() {
      this.loadingStatus = true
      courseApi.singleStatusActionOnClass(this.updatingItem).finally(() => {
        this.showUpdateStatus = false
        this.$emit("getData", {...this.filterSearch, is_archive: false})
      }).finally(()=> {
        this.loadingStatus = false
      })
    },
    confirmArchive() {
      this.loadingArchive = true
      courseApi.archiveClass(this.updatingItem).finally(() => {
        this.showArchive = false
        this.$emit("getData", {...this.filterSearch, is_archive: false})
      }).finally(()=> {
        this.loadingArchive = false
      })
    },
    changePage() {
      this.$router.push({
        query: {
          ...this.$route.query,
          page: this.filterSearch.page
        }
      })
      this.$emit("getData", {...this.filterSearch, is_archive: false})
    },
    updateIds() {
      let ids = this.idList.map(item => item.id)
      this.$emit('updateIds', ids)
    },
    addUser(item) {
      this.$router.push(`/courses/class/users/${item.id}`)
    }
  }
}
</script>

<style scoped>
.green-title {
  color: #138B6E;
  background-color: #D8F8FF;
  border-radius: 10px;
}

.red-title {
  color: #FF4079;
  background-color: #FFDEF6;
  border-radius: 10px;
}
</style>
